import { Location } from "@angular/common";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { SessionService } from "src/app/session.service";
import { CommonService } from "src/app/views/common/services/common.service";
import { OpSitesService } from "src/app/views/common/services/op-sites.service";

declare var $: any;

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
})
export class NavigationComponent implements AfterViewInit, OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  FTPPRogress = [];
  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;
  siteIds: string[] | null = null;
  selectedSiteId: any;
  userType: string;
  userInfo: any = JSON.parse(sessionStorage.getItem("userInfo"));
  siteGroupName: any = sessionStorage.getItem("siteGroupName");
  sites: any;

  constructor(
    private sessionServ: SessionService,
    private modalService: NgbModal,
    private siteServ: OpSitesService,
    private route: Router,
    private _location: Location,
    private commonServ: CommonService
  ) { }

  // This is for Notifications
  notifications: Object[] = [
    {
      btn: "btn-danger",
      icon: "ti-link",
      title: "Luanch Admin",
      subject: "Just see the my new admin!",
      time: "9:30 AM",
    },
    {
      btn: "btn-success",
      icon: "ti-calendar",
      title: "Event today",
      subject: "Just a reminder that you have event",
      time: "9:10 AM",
    },
    {
      btn: "btn-info",
      icon: "ti-settings",
      title: "Settings",
      subject: "You can customize this template as you want",
      time: "9:08 AM",
    },
    {
      btn: "btn-primary",
      icon: "ti-user",
      title: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM",
    },
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: "assets/images/users/1.jpg",
      status: "online",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:30 AM",
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "busy",
      from: "Sonu Nigam",
      subject: "I have sung a song! See you at",
      time: "9:10 AM",
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "away",
      from: "Arijit Sinh",
      subject: "I am a singer!",
      time: "9:08 AM",
    },
    {
      useravatar: "assets/images/users/4.jpg",
      status: "offline",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM",
    },
  ];
  onBack() {
    // let jobId = localStorage.getItem('Nursery_Manager_ViewJOB');
    // console.log("jobIdh", jobId);
    // this.route.navigate(["/AdminPanel/proofcard-uploader"], {
    //   queryParams: { id: jobId },
    // });
    this._location.back();
  }
  logout() {
    this.sessionServ.logout(true);
    // this.route.navigateByUrl("/authentication/login");
    this.route.navigateByUrl("/WebPanel/proofcard-login");
  }
  ngAfterViewInit() { }

  ngOnInit() {
    this.commonServ.updateProgress$.subscribe((res: any) => {
      this.FTPPRogress.push(res);
      this.FTPPRogress = [
        ...new Map(
          this.FTPPRogress.map((item) => [item["ftpRecord"], item])
        ).values(),
      ];
    });
    const userInfo = sessionStorage.getItem("userInfo");
    const siteInfo = sessionStorage.getItem("siteInfo");

    if (siteInfo) {
      let data = JSON.parse(userInfo);
      let siteData = JSON.parse(siteInfo);
      this.userType = data.userTypeName;
      this.siteIds = siteData;
      console.log(this.siteIds);
    }
    // this.selectedSiteId = this.siteIds && this.siteIds.length > 0 ? this.siteIds[0]["id"] : null;
    if (this.siteIds[0]) {
      this.selectedSiteId = this.siteIds[0]['id'];
      sessionStorage.setItem("selectedSiteId", this.selectedSiteId);
    }
  }
  onSiteSelect(selectedSiteId) {
    this.selectedSiteId = selectedSiteId;
    sessionStorage.setItem("selectedSiteId", this.selectedSiteId);
    const selectedId = this.selectedSiteId;
    console.log("Selected Site ID:", selectedId);
    this.commonServ.changeManagerSite();
  }
}
